// @flow
import * as React from 'react';
import styled from 'styled-components';
import theme from 'styled-theming';
import ScrollToTopOnMount from '../Routing/ScrollToTopOnMount';
import Themes from '../../styling/themes';

const backgroundColor = theme('mode', {
  light: Themes.light.pageHeadingBackgroundColor,
  dark: Themes.dark.pageHeadingBackgroundColor,
  custom: Themes.custom.pageHeadingBackgroundColor
});

const color = theme('mode', {
  light: Themes.light.pageHeadingColor,
  dark: Themes.dark.pageHeadingColor,
  custom: Themes.custom.pageHeadingColor
});

const Container = styled.div`
  align-items: center;
  background-color: ${backgroundColor};
  color: ${color};
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1rem;
`;

const PageHeading = (props: { children: React.Node }) => (
  <>
    <ScrollToTopOnMount />
    <Container>{props.children}</Container>
  </>
);

export default PageHeading;
